// <s-share>: "Copy link" copies the page URL; a native "Share" button appears on devices that support it.
class SShare extends HTMLElement {
  #ac;
  connectedCallback() {
    this.#ac = new AbortController();
    const { signal } = this.#ac;
    const status = this.querySelector('[data-share-status]');
    const copy = this.querySelector('[data-share-copy]');
    const native = this.querySelector('[data-share-native]');
    const url = copy?.dataset.url || window.location.href;

    if (native && navigator.share) {
      native.hidden = false;
      // Phones get one Share button (the system sheet covers every app), so hide the individual network buttons.
      this.querySelectorAll('[data-share-network]').forEach((el) => { el.hidden = true; });
      native.addEventListener('click', () => {
        navigator.share({ title: document.title, url }).catch(() => {});
      }, { signal });
    }

    copy?.addEventListener('click', async () => {
      try {
        await navigator.clipboard.writeText(url);
        if (status) status.textContent = this.dataset.copied || '';
        window.setTimeout(() => { if (status) status.textContent = ''; }, 2500);
      } catch (e) {
        window.prompt('', url);
      }
    }, { signal });
  }
  disconnectedCallback() { this.#ac?.abort(); }
}

if (!customElements.get('s-share')) customElements.define('s-share', SShare);
